import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {useClientsStore} from './ClientsStore';
import ClientsView from './ClientsView';
import {captureError} from '../../utils/log';
import subscriptionService from '../../services/subscription/SubscriptionService';

function ClientsContainer() {
  const organisation = useSelector(state => state.organisation);
  const {state: {depositor}, dispatch} = useClientsStore();
  const [plan, setPlan] = useState({loading: true});

  useEffect(() => {
    dispatch({type: 'FETCH_DATA'});
  }, []);

  useEffect(() => {
    const aborter = new AbortController();

    async function getSubscriptionPlan(organisationId) {
      try {
        if (depositor.loading || depositor.isActive) {
          // If organisation depositor service status loading or active, no need to fetch plan upgradable status
          return;
        }

        setPlan({loading: true});
        // User is not depositor, fetch subscription plan upgradable status
        const [currentSubscription, ofaPlan] = await Promise.all([
          subscriptionService.findSubscriptionByOrganisation(organisationId, aborter.signal),
          subscriptionService.getOrganisationPlan(organisationId, aborter.signal)
        ]);

        if (!currentSubscription || !ofaPlan) {
          // Can't determine plan
          return;
        }

        setPlan({
          depositorServiceAuthorized: currentSubscription.depositorServiceAuthorized,
          upgradable: Boolean(ofaPlan.upgradable)
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          captureError('Error while loading subscription plan details', error);
        }
      } finally {
        setPlan(current => ({...current, loading: false}));
      }
    }

    getSubscriptionPlan(organisation.organisationId);

    return () => {
      aborter.abort();
    };
  }, [depositor.isActive, depositor.loading, organisation.organisationId]);

  return (
    <ClientsView plan={plan}/>
  );
}

export default ClientsContainer;
